/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Damper_ExhaustInputs */



/**
* | output |
* | --- |
* | "Exhaust air damper" |
*
* @param {Air_Handler_Unit_Damper_ExhaustInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_damper_exhaust = /** @type {((inputs?: Air_Handler_Unit_Damper_ExhaustInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Damper_ExhaustInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust air damper")
	return /** @type {LocalizedString} */ ("Volet d'air rejeté")
});